import { Component, OnDestroy, OnInit, ViewEncapsulation, Output,
  EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl } from '@angular/forms';
import { debounceTime, pluck } from 'rxjs/operators';
import * as _ from 'lodash';

import { environment } from 'src/environments/environment';
import { Entity, ImgValidatorPipe } from '../shared/pipes/img-validator.pipe';
import { LoginService } from '../services/login.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { MainNavService } from '../services/main-nav.service';
import { UserSettingsHttpService } from '../user-settings/services/user-settings-http.service';
import { AuthenticationGuard } from '../guards/authentication.guard';


@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainNavComponent implements OnInit, OnDestroy {

  selectedItem: string;
  titleIcon: string;
  searchQuery: FormControl = new FormControl('');
  role$

  Links: Array<object> = [
    {
      title: 'Home',
      path: '/app/home',
      icon: 'assets/NavIcons/Home.svg',
      searchString: '',
      visible: ['User Administrator', 'Administrator', 'Management', 'Analyst', 'SAR Team', 'Auditor']
    },
    {
      title: 'Case Overview',
      path: '/app/case-manager',
      icon: 'assets/NavIcons/Case-overview.svg',
      searchString: 'case',
      visible: ['User Administrator', 'Administrator', 'Management', 'Analyst', 'SAR Team', 'Auditor']
    },
    {
      title: 'Monitoring',
      path: '/app/monitoring-manager',
      icon: 'assets/NavIcons/Monitoring.svg',
      searchString: '',
      visible: ['User Administrator', 'Administrator', 'Management', 'Analyst', 'SAR Team', 'Auditor']
    },
    {
      title: 'DXTective',
      path: '/app/graph-analytics',
      icon: 'assets/DXtective.svg',
      searchString: '',
      visible: ['User Administrator', 'Administrator', 'Management', 'Analyst', 'SAR Team', 'Auditor']
    },

    {
      title: 'SAR Officer',
      path: '/app/sar',
      icon: 'assets/NavIcons/SAR-officer.svg',
      searchString: '',
      visible: ['User Administrator', 'Administrator', 'Management', 'Analyst', 'SAR Team', 'Auditor']
    },
    {
      title: 'MLRO View',
      path: '/app/statistics',
      icon: 'assets/NavIcons/MLRO-view.svg',
      searchString: '',
      visible: ['User Administrator', 'Administrator', 'Management', 'SAR Team', 'Auditor'],
    },
    {
      title: 'Leadership View',
      path: '/app/leadership',
      icon: 'assets/NavIcons/Leadership-view.svg',
      searchString: 'rules',
      visible: ['User Administrator', 'Administrator', 'Management', 'SAR Team', 'Auditor']
    },
    {
      title: 'User Management',
      path: '/app/users-management',
      icon: 'assets/NavIcons/User-management.svg',
      searchString: '',
      visible: ['User Administrator', 'Administrator', 'Management', 'SAR Team', 'Auditor']
    },
    {
      title: 'Audit Trail',
      path: '/app/audit-trail',
      icon: 'assets/NavIcons/Audit-trail.svg',
      searchString: '',
      visible: ['User Administrator', 'Administrator', 'Management', 'SAR Team', 'Auditor']
    },
    {
      title: 'Upload Data',
      path: '/app/upload-data',
      icon: 'assets/NavIcons/Upload-data.svg',
      searchString: '',
      visible: ['User Administrator', 'Administrator', 'Management', 'Analyst', 'SAR Team', 'Auditor']
    },
    {
      title: 'Settings',
      path: '/app/user-settings/general',
      icon: 'assets/settings-icon-active.svg',
      searchString: '',
      visible: []
    },
    {
      title: 'Settings',
      path: '/app/user-settings/password',
      icon: 'assets/settings-icon-active.svg',
      searchString: '',
      visible: []
    },
    {
      title: 'Settings',
      path: '/app/user-settings/risks',
      icon: 'assets/settings-icon-active.svg',
      searchString: '',
      visible: []
    }
  ];

  serverUrl = environment.serverUrl;
  userName: string;
  userImg: string;
  currentPath: any;
  timeout = null;
  searchList: any;

  @Output() onQuerySuggestionClick = new EventEmitter<{ query : string }>();

  constructor(
    public router: Router,
    public loginService: LoginService,
    public userSettings: UserSettingsHttpService,
    private snackBar: MatSnackBar,
    private storage: StorageService,
    private mainService: MainNavService,
    private imgValidatorPipe: ImgValidatorPipe,
  ) { }

  ngOnInit(): void {
    this.userName = this.storage.getItem('name');
    this.imgValidatorPipe.transform(this.storage.getItem('avatar'), Entity.User).subscribe((blobURL) => {
      this.userImg = blobURL;
    });
    this.currentPath = this.Links.find((link: any) => this.router.url.includes(link.path));
    [this.selectedItem, this.titleIcon] = [this.currentPath.title, this.currentPath.icon];
    this.onStorageChanges();
    this.onSearchChanges();
    this.role$ = this.userSettings.getUserDetails().pipe(
      pluck('role')
    )
  }

  ngOnDestroy(): void {
  }

  navigateTo(path, title, icon) {
    this.selectedItem = title;
    this.titleIcon = icon;
    // const activeEl = document.getElementsByClassName('active');
    this.router.navigate([path]);
  }

  logout() {
    this.loginService.logout();
  }

  goToPage(group, value) {
    switch (group.category) {
      case 'Case':
        if (value.split('_')[1] === 'CMS') {
          this.router.navigate(['app/case-manager/user-case/' + value.substring(5)]);
        } else {
          this.router.navigate(['app/case-manager/' + value.substring(5)]);
        }  
        break;
      case 'User':
        this.router.navigate(['/app/users-management']);
        break;
      case 'Rule':
        this.router.navigate(['app/monitoring-manager']);
        break;
    }
  }

  searchAPI(value) {
    if (value === '') {
      this.searchList = null;
      return;
    }
    clearTimeout(this.timeout);
    this.mainService.generalSearch(value)
      .subscribe(
        (response: any) => {
          const searchHit = response.hits.hits;
          this.searchList = this.filterSearchByCategory(searchHit);
          if (_.isEmpty(searchHit)) {
            this.snackBar.open('No matches found', 'close', {
              duration: 4000
            });
          }
        },
        () => {
          this.snackBar.open('Search failed', 'close', {
            duration: 4000
          });
        }
      );
  }

  filterSearchByCategory(all: any[] = []): any[] {
    const users = all.filter(item => item?._index === SearchType.User);
    const cases = all.filter(item => item?._index === SearchType.Case);
    const rules = all.filter(item => item?._index === SearchType.Rule);
    return [
      {category: 'User', result: this.mapSearch(users, SearchType.User)},
      {category: 'Case', result: this.mapSearch(cases, SearchType.Case)},
      {category: 'Rule', result: this.mapSearch(rules, SearchType.Rule)}
    ];
  }

  mapSearch(data: any[], type: SearchType): string[] {
    switch (type) {
      case SearchType.User:
        return data.map(user => `${user._source.first_name} ${user._source.last_name}`);
      case SearchType.Case:
        return data.map(c => c._source.case_code);
      case SearchType.Rule:
        return data.map(rule => rule._source.name);
    }
  }

  onSearchChanges(): void {
    this.searchQuery.valueChanges
      .pipe(
        // throttleTime(500),
        debounceTime(500)
      )
      .subscribe(value => {
        if ((value || '').length > 0) {
          this.searchAPI(value);
        }
      });
  }

  onStorageChanges() {
    this.storage.watchStorage().subscribe(key => {
      if (key === 'avatar') {
        this.imgValidatorPipe.transform(this.storage.getItem('avatar'), Entity.User).subscribe((blobURL) => {
          this.userImg = blobURL;
        });
      }
    });
  }
}

enum SearchType {
  User = 'user_search',
  Case = 'case_search',
  Rule = 'rule_search'
}
